import { Clock, Instagram, MapPin, UtensilsCrossed } from "lucide-react";
import { ADDRESS, HOURS, LINKS } from "../data/content";
import { CONVERSIONS, reportConversion } from "../utils/gtag";
import { Eyebrow, Reveal } from "./Reveal";

export default function Visit() {
  return (
    <section id="visit" className="relative overflow-hidden border-t border-neon/10" data-testid="visit-section">
      <div className="pointer-events-none absolute -right-40 top-0 h-[500px] w-[500px] rounded-full bg-leaf/30 blur-[160px]" />
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <Eyebrow>Find us</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-cream sm:text-4xl lg:text-5xl">
            Walk in. <em className="italic text-neon">We'll handle the rest.</em>
          </h2>
          <p className="mt-6 flex max-w-md items-start gap-3 text-base leading-relaxed text-sage" data-testid="visit-address">
            <MapPin size={18} className="mt-1 shrink-0 text-neon" />
            {ADDRESS}
          </p>
          <div className="mt-6 space-y-2" data-testid="visit-hours">
            {HOURS.map((h) => (
              <p key={h.days} className="flex items-center gap-3 text-sm text-mist">
                <Clock size={14} className="text-neon/70" />
                <span className="w-44 font-mono text-[11px] uppercase tracking-[0.15em]">{h.days}</span>
                <span className="text-sage">{h.time}</span>
              </p>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href={LINKS.maps}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-directions-btn"
              onClick={() => reportConversion(CONVERSIONS.directions)}
              className="group flex items-center gap-2.5 rounded-full bg-neon px-8 py-4 font-medium text-espresso shadow-[0_0_45px_rgba(255,184,0,0.3)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_70px_rgba(255,184,0,0.5)]"
            >
              <MapPin size={17} className="transition-transform duration-300 group-hover:-translate-y-0.5" />
              Get Directions
            </a>
            <a
              href={LINKS.zomatoOrder}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="visit-zomato-btn"
              onClick={() => reportConversion(CONVERSIONS.zomatoOrder)}
              className="group flex items-center gap-2.5 rounded-full border border-cream/25 px-8 py-4 font-medium text-cream transition-all duration-300 hover:border-neon/60 hover:text-neon"
            >
              <UtensilsCrossed size={17} />
              Order on Zomato
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="flex h-full flex-col gap-4">
            <div className="relative min-h-[340px] flex-1 overflow-hidden rounded-2xl border border-cream/8" data-testid="visit-map">
              <iframe
                title="Brewing Bistro on Google Maps — Baner, Pune"
                src="https://maps.google.com/maps?q=Brewing%20Bistro%2C%20Baner%2C%20Pune&z=16&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                className="absolute inset-0 h-full w-full grayscale-[35%] contrast-[1.05]"
              />
              <span className="absolute left-4 top-4 rounded-full border border-neon/30 bg-espresso/70 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-neon backdrop-blur-sm">
                Baner · Pune
              </span>
            </div>
            <a
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="visit-instagram-link"
              className="group flex items-center justify-center gap-2.5 rounded-full border border-cream/25 px-8 py-4 font-medium text-cream transition-all duration-300 hover:border-neon/60 hover:text-neon"
            >
              <Instagram size={17} className="transition-transform duration-300 group-hover:rotate-12" />
              Follow @brewing_bistro_baner
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
